var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaulDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 32.75C3.32174 32.75 2.4315 32.3813 1.77513 31.7249C1.11875 31.0685 0.75 30.1783 0.75 29.25V1.25H16.5L25.25 10V29.25C25.25 30.1783 24.8813 31.0685 24.2249 31.7249C23.5685 32.3813 22.6783 32.75 21.75 32.75H4.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 1.25V11.75H25.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaulDoc);
export default __webpack_public_path__ + "static/media/defaulDoc.2ec575b07e95cdf5a0254e3a44cb393d.svg";
export { ForwardRef as ReactComponent };